<template>
  <div id="organizationStructure">
    <div class="orgLeft" :style="myAutoContent">
      <el-container style="height:100%;width:100%">
        <el-header style="height:auto;margin-top:14px;margin-bottom:1px">
          <el-input placeholder="输入关键字进行过滤" v-model.trim="filterText"></el-input>
        </el-header>
        <el-main style="height:100%;width:100%;">
          <el-tree
            :props="defaultProps"
            node-key="id"
            :load="loadNode"
            lazy
            accordion
            :expand-on-click-node="false"
            ref="tree2"
            @node-click="handleNodeClick"
            :filter-node-method="filterNode"
            :default-expanded-keys="showKeyArray"
            :highlight-current="true"
            class="treeClass"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span v-if="data.level==0">
                <span class="fa fa-folder-open fa-fw">&nbsp;{{node.label}}</span>
              </span>
              <span v-else-if="data.level==1">
                <span class="fa fa-folder-open-o fa-fw">&nbsp;{{node.label}}</span>
              </span>
              <span v-else>
                <span class="fa fa-folder-o fa-fw">&nbsp;{{node.label}}</span>
              </span>
            </span>
          </el-tree>
        </el-main>
      </el-container>
    </div>

    <div class="orgRight" :style="myAutoContent">
      <!-- 操作栏 -->
      <div class="commonSearch" ref="commonSearchRef">
        <el-form class="el-form el-form--inline">
          <el-form-item v-if="this.overAllLevel==0">
            <el-button
              type="primary"
              plain
              icon="el-icon-edit"
              @click="openCompanyEditDlg('','')"
            >&nbsp;&nbsp;添加公司</el-button>
          </el-form-item>
          <el-form-item v-if="this.overAllLevel==1">
            <el-button
              type="primary"
              plain
              icon="el-icon-edit"
              @click="openCompanyEditDlg('','')"
            >&nbsp;&nbsp;添加公司</el-button>
          </el-form-item>
          <el-form-item v-if="this.overAllLevel==1">
            <el-button
              type="primary"
              plain
              icon="el-icon-edit"
              @click="openDeptEditDlg('','')"
            >&nbsp;&nbsp;添加部门</el-button>
          </el-form-item>
          <el-form-item v-if="this.overAllLevel==2">
            <el-button
              type="primary"
              plain
              icon="el-icon-edit"
              @click="openDeptEditDlg('','')"
            >&nbsp;&nbsp;添加部门</el-button>
          </el-form-item>
          <div style="clear:both"></div>
        </el-form>
      </div>

      <div class="myTable">
        <el-table
          :data="nextChildrenData"
          style="width: 100%"
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          element-loading-text="拼命加载中"
          v-loading="loading"
          size="medium"
          :height="myTabHeight"
        >
          <!-- <el-table-column type="selection" width="55"  @selection-change="handleSelectionChange"></el-table-column> -->
          <!-- <el-table-column prop="label" label="机构编号" align="center"></el-table-column> -->
          <el-table-column prop="name" label="机构名称" align="left">
            <template slot-scope="scope">
              <span v-if="scope.row.level==0" class="fa fa-folder-open">&nbsp;{{scope.row.name}}</span>
              <span v-if="scope.row.level==1" class="fa fa-folder-open-o">&nbsp;{{scope.row.name}}</span>
              <span v-if="scope.row.level==2" class="fa fa fa-folder-o">&nbsp;{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="所在地址" align="left"></el-table-column>
          <el-table-column prop="principal" label="负责人" align="left"></el-table-column>
          <el-table-column prop="phone" label="联系电话" align="left" width="150"></el-table-column>
          <el-table-column prop="disabled" label="状态" align="left" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.disabled==0" style="color: green;font-weight:bold">正常</span>
              <span v-if="scope.row.disabled==1" style="color: red;font-weight:bold">禁用</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="label" label="区域编码" align="center"></el-table-column> -->
          <el-table-column label="操作" width="200" align="left">
            <template slot-scope="scope">
              <span
                style="cursor:pointer"
                type="primary"
                class="fa fa-edit fa-2x btnColor"
                v-if="scope.row.level==1"
                @click="openCompanyEditDlg(scope.$index, scope.row)"
                title="编辑"
              ></span>
              <span
                style="cursor:pointer"
                type="primary"
                class="fa fa-edit fa-2x btnColor"
                v-if="scope.row.level==2"
                @click="openDeptEditDlg(scope.$index, scope.row)"
                title="编辑"
              ></span>
              <span
                style="margin-left:10px;cursor:pointer"
                class="fa fa-times-circle-o fa-2x btnColor"
                @click="deleteData(scope.row.id)"
                title="删除"
              ></span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 分页框 -->
    <div class="commonPage">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[5, 10, 15, 30]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        :disabled="loading"
      ></el-pagination>
    </div>

    <div>
      <OrganizationDlg
        v-if="organizationDlgShow"
        @node-data="hanndleCallData"
        ref="organizationDlgRef"
      ></OrganizationDlg>
    </div>
    <DeptEditDlg v-if="deptEditDlgShow" ref="deptEditDlgRef"></DeptEditDlg>
    <CompanyEditDlg v-if="companyEditDlgShow" ref="companyEditDlgRef"></CompanyEditDlg>
  </div>
</template>

<script>
let id = 1000;
import bus from "@/utils/Bus.js";
import OrganizationDlg from "../organizationManage/OrganizationDlg.vue";
import DeptEditDlg from "./OrganizationManageDeptEditDlg.vue";
import CompanyEditDlg from "./OrganizationManageCompanyEditDlg.vue";
import TabResize from "@/utils/TabResizeEx.js";
import SettingApi from "@/api/setting.js";

import _ from "lodash";
export default {
  mixins: [TabResize],
  components: {
    OrganizationDlg,
    DeptEditDlg,
    CompanyEditDlg
  },
  mounted: function() {
    //初始化
    this.$nextTick(() => {
      this.loading = false;
      this.myAutoContent.height = this.myAutoContentHeight + "px";
      this.myTabHeight = this.myAutoContentInnerHeight + "px";
    });
    if (this.$constant.DEV_MODE) {
      console.log("-- OrganizationStructure addEventListener  resize ---");
    }
    window.addEventListener("resize", this.$mainResize);
  },
  computed: {
    myAutoContentHeight() {
      return this.getMyAutoContentHeight();
    },
    myAutoContentInnerHeight() {
      return this.getMyAutoContentInnerHeight();
    },
    $mainResize() {
      return _.debounce(() => {
        if (this.myAutoContent.height) {
          this.myAutoContent.height = this.getMyAutoContentHeight() + "px";
          this.myTabHeight = this.getMyAutoContentInnerHeight() + "px";
        } else {
          if (this.$constant.DEV_MODE) {
            console.log(" this.myAutoContentHeight 不存在");
          }
        }
      }, 400);
    }
  },
  deactivated() {
    if (this.$constant.DEV_MODE) {
      console.log("-- OrganizationStructure removeEventListener  resize ---");
    }
    window.removeEventListener("resize", this.$mainResize);
  },
  data() {
    return {
      myAutoContent: {
        height: "600px",
        "overflow-y": "auto"
      },
      // 声明保存当前操作的NODE 对象
      deptEditDlgShow: false,
      companyEditDlgShow: false,
      timeFlag: false,
      currentNode: null,
      overAllLevel: "",
      currentNodeType: 0,
      currentNodeId: 0,
      myTabHeight: 400,
      defaultProps: {
        children: "children",
        label: "name",
        isLeaf: "leaf"
      },
      filterText: "",
      loading: true,
      showKeyArray: [],
      nextChildrenData: [],
      listGroup: [], //完整组织架构
      listGroupBranchOrDept: [], //完整组织架构
      multipleSelection: [],
      parentId: "",
      parentName: "",
      organizationDlgShow: false,
      cur_page: 1,
      totalCount: 0,
      orgCount: 0,
      per_page: this.$constant.PAGE_SIZE
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree2.filter(val);
    }
  },
  methods: {
    getMyAutoContentHeight() {
      let defTagsHeight = this.$constant.DEF_TAGS_HEIGHT;
      let defSearchHeight = 0;
      let defHomeHeight = 600;

      if (this.$refs.commonSearchRef) {
        defSearchHeight = this.$refs.commonSearchRef.clientHeight;
      }
      if (
        this.$parent.$refs.myHomeTagsRef &&
        this.$parent.$refs.myHomeTagsRef.$refs.myTagsRef
      ) {
        defTagsHeight = this.$parent.$refs.myHomeTagsRef.$refs.myTagsRef
          .clientHeight;
      }

      defHomeHeight =
        window.innerHeight -
        this.$constant.DEF_HEADER_HEIGHT -
        defTagsHeight -
        this.$constant.DEF_PADDING_HEIGHT -
        defSearchHeight;
      return defHomeHeight;
    },
    getMyAutoContentInnerHeight() {
      let autoContentHeight = this.getMyAutoContentHeight();
      let defHomeHeight = 400;
      let defOperHeight = 47;
      if (this.$refs.commonOperBtnRef) {
        defOperHeight = this.$refs.commonOperBtnRef.clientHeight;
      }
      defHomeHeight = autoContentHeight - defOperHeight;
      return defHomeHeight;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    //获取选中行
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onloadGroup(node, resolve) {
      SettingApi.getClass()
        .onloadOrgGroup()
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            let data = res2.data.data;
            this.listGroup = data;
            if (resolve) {
              resolve(this.listGroup);
            }
            this.showKeyArray = [];
            this.showKeyArray.push(data[0].id);
            //点击左边树之后this.parentId才会有值
            if (
              this.parentId != "" &&
              this.parentId != null &&
              this.parentId != undefined
            ) {
              this.$nextTick(() => {
                this.$refs.tree2.setCurrentKey(this.parentId);
              });
            } else {
              //赋值全局type
              this.overAllLevel = data[0].level;
              //赋值全局parentId
              this.parentId = data[0].id;
              this.parentName = data[0].name;

              this.currentNodeType = data[0].type;
              this.currentNodeId = data[0].id;
              this.$nextTick(() => {
                this.$refs.tree2.setCurrentKey(data[0].id);
              });
              if (this.timeFlag == false) {
                this.timeFlag = true;
                this.getListData(data[0].id);
              }
            }
          } else {
            this.$message.error(res2.data.msg);
            resolve([]);
            return false;
          }
        })
        .catch(err => {
          this.$message.error(err);
          resolve([]);
          return false;
        });
    },
    onloadGroupNextChild(type, id, resolve) {
      let param = {};
      //获取组织架构数据
      // this.$mhttp.httpGet(
      //   this.$constant.API_NSC + "uc/dept/depts/" + id,
      //   null,
      //   null
      // );

      SettingApi.getClass()
        .onloadOrgGroupNextChild(id)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            this.listGroupBranchOrDept = res2.data.data;
            // this.nextChildrenData = res2.data.data;
            if (resolve) {
              resolve(this.listGroupBranchOrDept);
            }
          } else {
            this.$message.error(res2.data.msg);
            resolve([]);
            return false;
          }
        })
        .catch(err => {
          this.$message.error(err);
          resolve([]);
          return false;
        });
    },
    getListData(id) {
      this.loading = true;
      let param = {
        id: id,
        pageNum: this.cur_page,
        pageSize: this.per_page
      };
      SettingApi.getClass()
        .getOrgListData(param)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            this.totalCount = res2.data.data.totalElements;
            this.nextChildrenData = res2.data.data.data;
            this.loading = false;
          } else {
            this.$message.error(res2.data.msg);
            this.loading = false;
            return false;
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err);
          return false;
        });
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        this.onloadGroup(node, resolve);
        return;
      }
      if (node.level === 1) {
        this.currentNode = node;
      }
      setTimeout(() => {
        this.onloadGroupNextChild(node.data.type, node.data.id, resolve);
      }, 500);
    },
    refreshTree(operType) {
      if (this.currentNode) {
        let param = {
          type: this.currentNodeType,
          id: this.currentNodeId
        };
        SettingApi.getClass()
          .onloadOrgGroupNextChild(this.currentNodeId)
          .then(res2 => {
            if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
              let oldChildData = this.currentNode.childNodes;
              oldChildData.splice(0, oldChildData.length);
              this.currentNode.doCreateChildren(res2.data.data);
              if (operType == "add") {
                if (this.currentNode.isLeaf == true) {
                  this.currentNode.isLeaf = false;
                }
              } else if (operType == "del") {
                if (this.currentNode.childNodes.length == 0) {
                  if (this.currentNode.isLeaf == false) {
                    this.currentNode.isLeaf = true;
                  }
                }
              }
            } else {
              this.$message.error(res2.data.msg);
              return false;
            }
          })
          .catch(err => {
            this.$message.error(err);
            return false;
          });
      }
    },
    handleNodeClick(data, node, vuecomponent) {
      // console.log(
      //   "data:",
      //   data,
      //   "\n",
      //   "node:",
      //   node,
      //   "\n",
      //   "vuecomponent",
      //   vuecomponent
      // );
      //点击左边树给全局id 和 name 赋值
      this.parentId = data.id;
      this.parentName = data.name;
      this.overAllLevel = data.level;
      this.getListData(data.id);
    },
    hanndleCallData(nodeData) {
      console.log(nodeData);
    },
    openDeptEditDlg(index, row) {
      this.deptEditDlgShow = true;
      let operateFlag = "";
      let param = {
        parentId: this.parentId,
        parentName: this.parentName
      };
      if (row != null && row != "") {
        operateFlag = "update";
        this.$nextTick(() => {
          this.$refs.deptEditDlgRef.init(param, row, operateFlag);
        });
      } else {
        operateFlag = "add";
        this.$nextTick(() => {
          this.$refs.deptEditDlgRef.init(param, "", operateFlag);
        });
      }
    },
    openCompanyEditDlg(index, row) {
      this.companyEditDlgShow = true;
      let operateFlag = "";
      let param = {
        parentId: this.parentId,
        parentName: this.parentName
      };
      if (row != null && row != "") {
        operateFlag = "update";
        this.$nextTick(() => {
          this.$refs.companyEditDlgRef.init(param, row, operateFlag);
        });
      } else {
        operateFlag = "add";
        this.$nextTick(() => {
          this.$refs.companyEditDlgRef.init(param, "", operateFlag);
        });
      }
    },
    //切换每页显示多条
    handleSizeChange(val) {
      this.per_page = val;
      this.cur_page = 1;
      this.loading = true;
      this.getListData(this.parentId);
    },
    // 切换显示第几页
    handleCurrentChange(val) {
      this.cur_page = val;
      this.loading = true;
      this.getListData(this.parentId);
    },
    //删除数据
    deleteData(id) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      })
        .then(() => {
          if (id != null && id != "" && id != undefined) {
            this.loading = true;
            SettingApi.getClass()
              .deleteOrgById(id)
              .then(res2 => {
                if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                  this.$message.success("删除成功！");
                  this.loading = false;
                  this.refreshTree("del");
                  this.refreshData();
                  this.$nextTick(() => {
                    this.$refs.tree2.setCurrentKey(this.parentId);
                  });
                } else {
                  this.$message.error(res2.data.msg);
                  this.loading = false;
                  return false;
                }
              })
              .catch(err => {
                this.$message.error(err);
                this.loading = false;
                return false;
              });
          }
        })
        .catch(() => {});
    },
    refreshData() {
      let length = this.multipleSelection.length;
      if (length == null || length == "") {
        length = 1;
      }
      let m = Math.ceil((this.totalCount - length) / this.per_page);
      if (this.cur_page > 1 && this.cur_page > m) {
        this.cur_page = this.cur_page - 1;
      }
      this.onloadGroup();
      this.getListData(this.parentId);
    }
  }
};
</script>


<style lang="stylus" scoped>
#organizationStructure {
  width: 100%;

  .orgLeft {
    width: $dept-left-width;
    margin-left: $content-margin-left;
    float: left;
    background-color: white;
    border-radius: $border-radius;
    box-shadow: $box-shadow;
  }

  .orgRight {
    margin-top: $content-margin-top;
    background-color: white;
    width: auto;
    margin-left: $dept-left-margin;
    margin-right: $content-margin-right;
    border-radius: $border-radius;
    box-shadow: $box-shadow;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: $default-font;
    padding-right: 8px;
  }

  .btnColor {
    color: $theme-color;
  }

  .treeClass >>> .el-tree-node__children {
    overflow: inherit !important;
  }

  .treeClass >>> .el-tree-node__content {
    width: 100%;
  }
}
</style>


